import { ProductInspectionSampleDto } from "./product-inspection-samples.dto";

export class ProductInspectionDto{
    inspectionId: number;
    saleOrderId: number;
    saleOrderItemId: number;
    lotNumber:string;
    section:string;
    date:Date;
    isActive: boolean;
    createdAt: Date;
    createdUser: string | null;
    updatedAt: Date;
    updatedUser: string | null;
    versionFlag: number
    samplesInfo: ProductInspectionSampleDto[];
    soNumber?:string
    item?:string


}